/**
 * Status band — sits directly under a card's header, one per active state.
 * Per assets/handoffs/design_handoff_billing: the badge names the state,
 * the band adds only what the badge can't say (the date, the consequence,
 * the action).
 *
 * @param {'info'|'warn'|'err'|'gray'} kind
 * @param {ReactNode} icon
 * @param {ReactNode} title
 * @param {ReactNode=} children - the ".exp" body line
 * @param {{label: string, onClick: function, disabled?: boolean}=} action - right-aligned link
 */
import React from "react";
import classNames from "classnames";
import styles from "./Band.module.scss";

const Band = ({ kind = "gray", icon, title, children, action }) => (
  <div className={classNames(styles.root, styles[`root--${kind}`])}>
    <span className={styles.icon}>{icon}</span>
    <div className={styles.text}>
      <b className={styles.title}>{title}</b>
      {children && <p className={styles.body}>{children}</p>}
    </div>
    {action && (
      <button
        type="button"
        className={styles.action}
        onClick={action.onClick}
        disabled={action.disabled}
      >
        {action.label}
      </button>
    )}
  </div>
);

export default Band;
